module.exports = __webpack_public_path__ + "static/media/covera-mobile.51fa3458.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/covera-mobile.jpg
// module id = 48
// module chunks = 0